import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { rootReducer } from "./rootReducer";
import type { RootState } from "./rootReducer";
import rootSaga from "./rootSaga";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'MP_ROOT',
  storage,
  whitelist: ['auth'],
  blacklist: ['loyaltyProgram', 'customers'],
};

const persistedReducer = persistReducer<ReturnType<typeof rootReducer>>(persistConfig, rootReducer as any);

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const Store = createStore(
  persistedReducer,
  composeEnhancers(
    applyMiddleware(sagaMiddleware)
  )
);

sagaMiddleware.run(rootSaga);

const persistor = persistStore(Store);

export type { RootState };
export type AppDispatch = typeof Store.dispatch;
export default Store;
export { Store, persistor };
